import { render, staticRenderFns } from "./SubManageDialog.vue?vue&type=template&id=850359c6&scoped=true&"
import script from "./SubManageDialog.vue?vue&type=script&lang=ts&"
export * from "./SubManageDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SubManageDialog.vue?vue&type=style&index=0&id=850359c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850359c6",
  null
  
)

export default component.exports